export default __webpack_public_path__ + "static/media/flower.6dae8073.png";